import BaseInputsGrid from "@/components/reusables/BaseInputsGrid";
import BaseIntegrationIcon from "@/components/reusables/BaseIntegrationIcon";
import { isSystemIntegratedSelector } from "@/redux/features/auth/authSlice";
import { useAppSelector } from "@/redux/hooks";
import { SaleOrder } from "@/types/general";
import { useTranslation } from "react-i18next";

type ViewIntegrationsSectionProps = {
    saleOrder: SaleOrder.Extended;
};

export default function ViewIntegrationsSection({ saleOrder }: ViewIntegrationsSectionProps) {
    const { t } = useTranslation("", {
        keyPrefix: "sales.orders.integrations",
    });

    const isTwentyFourSevenOfficeEnabled = useAppSelector(
        isSystemIntegratedSelector("twenty_four_seven_office")
    );

    if (!isTwentyFourSevenOfficeEnabled) {
        return null;
    }

    return (
        <>
            <BaseInputsGrid title={t("header")}>
                {isTwentyFourSevenOfficeEnabled && !!saleOrder.project && (
                    <div>
                        <div className="mb-2 flex items-center space-x-2">
                            <BaseIntegrationIcon integration="twenty_four_seven_office" />
                            <span className="font-semibold">{t("fields.project.label")}</span>
                        </div>
                        <div className="space-x-[24px] text-accent">{saleOrder.project.name}</div>
                    </div>
                )}
            </BaseInputsGrid>
        </>
    );
}
